import styled from '@emotion/styled'

export const ClearGeoButton = styled.p`
  color: #289c91;
  font-size: 16px;
  :hover {
    cursor: pointer;
    color: #fa2d35;
  }
`

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 24px;
`

export const MapContainer = styled.div`
  height: 370px;
`

export const MapWrapper = styled.div`
  width: calc(100% - 46px);
`

export const SearchContainer = styled.div`
  display: flex;
  justify-content: center;
  position: relative;
`
